import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
    {
        id: "po-05-h0v5-01",
        name: "PO 01 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 86, y: 242, width: 210, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 303, y: 242, width: 210, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 521, y: 242, width: 210, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 739, y: 242, width: 210, height: 299, rotation: 0, imageRotation: 0 },
            { id: "5", x: 957, y: 242, width: 210, height: 299, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-02",
        name: "PO 02 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 221, width: 245, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 252, y: 221, width: 245, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 505, y: 221, width: 244, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 756, y: 221, width: 244, height: 343, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1008, y: 221, width: 244, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-03",
        name: "PO 03 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 124, y: 260, width: 186, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 260, width: 186, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 260, width: 185, height: 264, rotation: 0, imageRotation: 0 },
            { id: "4", x: 847, y: 260, width: 185, height: 264, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1039, y: 260, width: 185, height: 264, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-04",
        name: "PO 04 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 57, y: 152, width: 342, height: 479, rotation: 0, imageRotation: 0 },
            { id: "2", x: 406, y: 152, width: 169, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 406, y: 395, width: 169, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 206, width: 263, height: 371, rotation: 0, imageRotation: 0 },
            { id: "5", x: 942, y: 206, width: 263, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-05",
        name: "PO 05 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 83, y: 152, width: 353, height: 479, rotation: 0, imageRotation: 0 },
            { id: "2", x: 442, y: 152, width: 115, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 315, width: 115, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 442, y: 476, width: 115, height: 155, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 152, width: 343, height: 479, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-06",
        name: "Hr 06 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 97, y: 87, width: 432, height: 609, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 87, width: 212, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 395, width: 212, height: 301, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 87, width: 212, height: 301, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 395, width: 212, height: 301, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-07",
        name: "PO 07 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 92, y: 209, width: 261, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 360, y: 150, width: 171, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 360, y: 395, width: 171, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 675, y: 209, width: 261, height: 366, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 209, width: 261, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-08",
        name: "PO 08 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 91, y: 85, width: 444, height: 613, rotation: 0, imageRotation: 0 },
            { id: "2", x: 701, y: 150, width: 354, height: 483, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1061, y: 150, width: 114, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1061, y: 314, width: 114, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1061, y: 477, width: 114, height: 156, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-09",
        name: "PO 09 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 71, y: 168, width: 312, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 390, y: 168, width: 154, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 395, width: 154, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 551, y: 168, width: 311, height: 446, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 168, width: 311, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-10",
        name: "PO 10 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 71, y: 168, width: 312, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 390, y: 168, width: 312, height: 446, rotation: 0, imageRotation: 0 },
            { id: "3", x: 709, y: 168, width: 312, height: 446, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1028, y: 168, width: 154, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1028, y: 395, width: 154, height: 220, rotation: 0, imageRotation: 0 }
        ],
    }
];